import * as Api from '@ViewModels';
import moment from 'moment';
import { getDisplayName } from '../../../../../models/NameUtils';
import { getDefaultDateStringValue } from '../../../../../models/UiUtils';

export const getContactFieldValue = (contact: Api.IContact, fieldId: string): string => {
	switch (fieldId) {
		case 'name':
			return getDisplayName(contact);
		case 'jobTitle':
			return contact.jobTitle || '';
		case 'birthday':
			return getBirthdayValue(contact);
		case 'anniversary':
			return getAnniversaryValue(contact);
		case 'age':
			return getAgeValue(contact);
		case 'lastInteraction':
			return getLastInteractionValue(contact);
		case 'creationDate':
			return getDefaultDateStringValue(contact.creationDate);
		default:
			return '';
	}
};

const getBirthdayValue = (contact: Api.IContact): string => {
	const birthdayKeyFact = contact.keyFactsCollection?.find(kf => kf.keyDate?.kind === Api.KeyDateKind.Birthday);
	if (birthdayKeyFact?.keyDate) {
		const { month, day } = birthdayKeyFact.keyDate;
		// Create a moment date with current year (just for formatting purposes)
		const date = moment()
			.month(month - 1)
			.date(day);
		return date.format('MMM DD');
	}
	return '';
};

const getAnniversaryValue = (contact: Api.IContact): string => {
	const anniversaryKeyFact = contact.keyFactsCollection?.find(kf => kf.keyDate?.kind === Api.KeyDateKind.Anniversary);
	if (anniversaryKeyFact?.keyDate) {
		const { month, day } = anniversaryKeyFact.keyDate;
		return `${month}/${day}`;
	}
	return '';
};

const getAgeValue = (contact: Api.IContact): string => {
	const birthdayKeyFact = contact.keyFactsCollection?.find(kf => kf.keyDate?.kind === Api.KeyDateKind.Birthday);
	if (birthdayKeyFact?.keyDate) {
		const { month, day } = birthdayKeyFact.keyDate;
		const today = new Date();
		const currentYear = today.getFullYear();
		const birthday = new Date(currentYear, month - 1, day);

		// Find the year from key fact text if available, otherwise estimate from earliest possible year
		const keyFactText = birthdayKeyFact.value || '';
		const yearMatch = keyFactText.match(/\b(19|20)\d{2}\b/);

		if (yearMatch) {
			const birthYear = parseInt(yearMatch[0], 10);
			let age = currentYear - birthYear;
			if (birthday > today) {
				age--;
			}
			return age.toString();
		}
	}
	return '';
};

const getLastInteractionValue = (contact: Api.IContact): string => {
	return getDefaultDateStringValue(contact.relationshipHealth?.lastInteractionDate);
};
